import { Category } from './Category';
export class Menu {
    imagepath: string;
    categories: Array<Category>;
    singleusecategories: Array<Category>;
    restaurantId: number;

    public static Make(obj: any): Menu {
        const menu = new Menu();
        Object.assign(menu, obj);
        return menu;
    }
}
